<template>
  <div class="container">
    <van-loading type="spinner" size="100px" />
    <p @click="uploadFacePhoto">身份核验中...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orgin: null,
    };
  },
  mounted() {
    this.getUrlData();
  },
  methods: {
    // 获取人脸照片
    getUrlData() {
        this.orgin =
          window.location.protocol +
          "//" +
          window.location.host +
          "/index.html#/" +
          "mobileCourseDetail";
      // this.orgin =
      //   window.location.protocol +
      //   "//" +
      //   window.location.host +
      //   "/#/" +
      //   "mobileCourseDetail";
      let params = {
        access_token: JSON.parse(sessionStorage.getItem("VideoToken"))[1],
        verify_token: JSON.parse(sessionStorage.getItem("VideoToken"))[0],
      };
      this.$api.get("/user/searchBaiduFace", params, (res) => {
        if (res.code == "SUCCESS") {
          this.uploadFacePhoto(res.data);
        }else{
            window.parent.postMessage("FAIL", this.orgin);
        }
      });
    },
    // 上传人脸识别照片并通信状态到父级页面
    uploadFacePhoto(res) {
      let param = {
        studyId: sessionStorage.getItem("studyId"),
        sectionId: sessionStorage.getItem("sectionId"),
        time: Number(sessionStorage.getItem("playTime")),
        faceImageUrl: res,
      };
      this.$axiosPackag.getMessageByAxios(
        "POST",
        "/userStudyResource/completeFaceVerify",
        null,
        param,
        null,
        (res) => {
          if (res.status == 0) {
            window.parent.postMessage("SUCCESS", this.orgin);
          } else {
            window.parent.postMessage("FAIL", this.orgin);
          }
        },
        (err) => {
          window.parent.postMessage("FAIL", this.orgin);
        }
      );
    },
  },
};
</script>

<style scoped>
.container {
  width: 320px;
  height: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.container p {
  margin-top: 20px;
  color: #6e6e6e;
}
</style>


// WEBPACK FOOTER //
// MobileVideoFace.vue?d6c6b47a